import {type MutationTree} from 'vuex';
import TopMessageHandler from '../../../library/topMessageHandler';

const mutations: MutationTree<NotificationState> = {
    callbackSet(state, callback)
    {
        state.callback = callback;
    },
    callbackReset(state)
    {
        state.callback = null;
    },
    error(state, error)
    {
        state.error = error;
    },
    markAsRead(state, entryId)
    {
        if (state.count)
        {
            state.count--;
            state.lastStorageTimestamp = Date.now();
        }

        for (const entry of state.entries)
        {
            if (entry.id === entryId)
            {
                entry.read = true;
                break;
            }
        }

        if (state.callback)
        {
            state.callback(entryId);
        }
    },
    markAllAsRead(state)
    {
        if (state.count)
        {
            state.count = 0;
            state.lastStorageTimestamp = Date.now();
        }

        for (let entry of state.entries)
        {
            entry.read = true;
        }

        if (state.callback)
        {
            state.callback();
        }

        TopMessageHandler.success('Alle Benachrichtigungen wurden als gelesen markiert.');
    },
    update(state, payload)
    {
        state.error = null;

        for (let key in payload)
        {
            if (payload.hasOwnProperty(key))
            {
                state[key] = payload[key];
            }
        }
    },
    markEntriesAsRead(state, entryIds: number[] | 'all')
    {
        for (const entry of state.entries)
        {
            if (entryIds === 'all' || entryIds.includes(entry.id))
            {
                if (state.callback)
                {
                    state.callback(entry.id);
                }
                entry.read = true;
            }
        }
    },
};

export default mutations;